import React, { useEffect, useRef } from 'react';
import "./Column.scss"
import RecordItem from '../../Record/RecordItem/RecordItem';
import Timeline from '../Timeline/Timeline';

const handleScroll = () => {
	const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  
	if (scrollTop === 0) {
	  // Если страница прокручена до самого верха, скрываем все псевдоэлементы
	  document.querySelectorAll('.first_day').forEach(firstDay => {
		firstDay.style.removeProperty('--show-pseudo-element');
	  });
	  
	  document.querySelectorAll('.last_day').forEach(lastDay => {
		lastDay.style.removeProperty('--show-pseudo-element');
	  });
	} else {
	  // Если страница прокручена вниз, проверяем видимость элементов
	  const firstDays = document.querySelectorAll('.first_day');
	  const lastDays = document.querySelectorAll('.last_day');
  
	  firstDays.forEach(firstDay => {
		const rect = firstDay.getBoundingClientRect();
		if (rect.top >= 0 && rect.bottom <= window.innerHeight) {
		  firstDay.style.setProperty('--show-pseudo-element', 'block');
		} else {
		  firstDay.style.removeProperty('--show-pseudo-element');
		}
	  });
  
	  lastDays.forEach(lastDay => {
		const rect = lastDay.getBoundingClientRect();
		if (rect.top >= 0 && rect.bottom <= window.innerHeight) {
		  lastDay.style.setProperty('--show-pseudo-element', 'block'); 
		} else {
		  lastDay.style.removeProperty('--show-pseudo-element'); 
		}
	  });
	}
  };

const Column = ({ element, slots = [], records = [], first = false }) => {

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  
	let headerClass = 'column__header';
	if (element.weekDay === 'ПН') {
		headerClass += ' first_day'; // Добавляем класс для понедельника
	} else if (element.weekDay === 'ВС') {
		headerClass += ' last_day'; // Добавляем класс для воскресенья
	}
	return (
		<>
			{element.today &&
				<Timeline />
			}
			<div className={"column" + (element.today ? " today" : "") + (element.past ? " past" : "") + (first ? " first" : "")}>
				<div className={headerClass}>
					{element.weekDay}<br></br>
					{element.dateStr}
				</div>
				<div className="column__slots">
					<div className="column__records">
						{records.map((record) => {
							return (
								<RecordItem
									record={record}
									column={element}
									key={record.id} />
							)
						})}
					</div>
					{slots.map((slot, index) => {
						if (index === slots.length - 1) return (<div key={element.date + '_' + slot}></div>)
						return (
							<div className="column__slots-item" key={element.date + '_' + slot} data-time={slot}></div>
						)
					})}

				</div>
			</div>
		</>
	);
};

export default Column;
